module.exports = __webpack_public_path__ + "static/img/banner_tp1.e5d9996.png";